import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/domains/shared/components/Dialog";
import {
  APP_UPDATE_PROMPT_ADMIN_PT,
  APP_UPDATE_PROMPT_TRANSLATIONS as T,
} from "@/domains/shared/appUpdatePrompt/appUpdatePromptConstants";
import { useAppUpdatePromptStore } from "@/domains/shared/appUpdatePrompt/appUpdatePromptStore";
import { getTranslation, useLocale } from "@mivo/i18n";
import { useLocation } from "react-router";

function useIsAdminPath(): boolean {
  const { pathname } = useLocation();
  return pathname.startsWith("/admin");
}

export function AppUpdateHardDialog() {
  useLocale();
  const isAdmin = useIsAdminPath();
  const hardActive = useAppUpdatePromptStore((s) => s.hardActive);
  const showUnsavedLossWarning = useAppUpdatePromptStore((s) => s.showUnsavedLossWarning);
  const autoReloadFailed = useAppUpdatePromptStore((s) => s.autoReloadFailed);
  const retryReload = useAppUpdatePromptStore((s) => s.retryReload);

  const title = isAdmin ? APP_UPDATE_PROMPT_ADMIN_PT.hardTitle : getTranslation(T.hardTitle);
  const body = isAdmin ? APP_UPDATE_PROMPT_ADMIN_PT.hardBody : getTranslation(T.hardBody);
  const unsaved = isAdmin
    ? APP_UPDATE_PROMPT_ADMIN_PT.unsavedLossWarning
    : getTranslation(T.unsavedLossWarning);
  const reloadLabel = isAdmin
    ? APP_UPDATE_PROMPT_ADMIN_PT.hardReload
    : getTranslation(T.hardReload);

  return (
    <Dialog
      open={hardActive}
      onOpenChange={() => {
        // BR-09 / E-15: non-dismissible — ignore Escape / outside close attempts.
      }}
    >
      <DialogContent
        dismissable={false}
        scrollBody
        data-app-update-hard-dialog
        data-app-update-prompt
        data-testid="app-update-hard-dialog"
        className="max-w-md"
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{body}</DialogDescription>
        </DialogHeader>
        <DialogBody>
          {showUnsavedLossWarning ? (
            <p className="text-sm text-destructive" data-testid="app-update-unsaved-warning">
              {unsaved}
            </p>
          ) : null}
        </DialogBody>
        {autoReloadFailed ? (
          <DialogFooter className="flex-row">
            <Button
              type="button"
              size="dialog"
              data-testid="app-update-hard-reload"
              onClick={() => {
                retryReload();
              }}
            >
              {reloadLabel}
            </Button>
          </DialogFooter>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
